type NoteSummary = {
  id: number;
  name: string;
};

export const formatAdditionalNotesFromIds = (values: Array<string | number>, notesById?: Record<number, string>) => {
  const mappedNotes = values
    .map((value) => {
      const noteId = typeof value === "string" ? Number(value) : value;
      if (Number.isNaN(noteId)) {
        return String(value);
      }
      const name = notesById?.[noteId];
      return name ? `${name} [${noteId}]` : `[${noteId}]`;
    })
    .filter((note) => note.length > 0);

  return mappedNotes.length > 0 ? mappedNotes.join(", ") : "N/A";
};

export const formatAdditionalNotesFromList = (notes?: NoteSummary[]) => {
  const notesWithIds = notes?.map((note) => `${note.name} [${note.id}]`) ?? [];
  return notesWithIds.length > 0 ? notesWithIds.join(", ") : "N/A";
};
